export const SET_TAG_FILTER = 'SET_TAG_FILTER';
export const ADD_TAG_FILTER_TYPE = 'ADD_TAG_FILTER_TYPE';
export const SET_TYPE_FILTER = 'SET_TYPE_FILTER';
export const SET_STATUS = 'SET_STATUS';
export const SET_HEALTH = 'SET_HEALTH';
export const SET_VEHICLE_ASSET = 'SET_VEHICLE_ASSET';
